(function () {
  var indent2em = (function () {
    "use strict";

    var global = tinymce.util.Tools.resolve("tinymce.PluginManager");
    var global$1 = tinymce.util.Tools.resolve("tinymce.util.Tools");

    var doAct = function (editor) {
      var dom = editor.dom;
      var blocks = editor.selection.getSelectedBlocks();
      var act = "";
      var indent2em_val = editor.getParam("indent2em_val", "2em");
      console.log(blocks);
      global$1.each(blocks, function (block) {
        // console.log(block);
        // 原本都是获取p标签字体大小，修改为获取span[data-mce-style]的字体大小，根据实际字体大小确定首行缩进
        var fontSize;
        if (
          block.children.length > 0 &&
          block.querySelector("span[data-mce-style]")
        ) {
          fontSize = block.querySelector("span[data-mce-style]").style.fontSize;
          console.log(block.children[0], fontSize);
          indent2em_val =
            2 * Number(fontSize.substring(0, fontSize.length - 2));
        }
        // 原本都为block,此处定义elem记录真正字体大小变化的元素
        var elem;
        if (act == "") {
          // 由于富文本编辑器中从第二段开始结构发生变化p>span，因此检测元素并获取带有data-mce-style的span设置状态标记和缩进

          elem =
            block.children.lenght > 0
              ? block.querySelector("span[data-mce-style]")
              : block;
          act = dom.getStyle(elem, "text-indent") ? "remove" : "add";
        }
        console.log(elem);

        if (act == "add") {
          if (block.children.length > 0) {
            for (const item of block.children) {
              // 修改内部span的首行缩进
              dom.setStyle(item, "text-indent", indent2em_val);
            }
          }
          // 修改外部p标签的首行缩进
          dom.setStyle(block, "text-indent", indent2em_val);
        } else {
          var style = dom.getAttrib(elem, "style");
          // console.log("elem", elem, style);
          // 此处修改了源码中的正则和元素
          style = style.replace(/text-indent/gi, "");
          // 移除内外span/p的首行缩进
          dom.setAttrib(elem, "style", style);
          dom.setAttrib(block, "style", style);
        }
      });
    };

    var register = function (editor) {
      editor.ui.registry.getAll().icons.indent2em ||
        editor.ui.registry.addIcon(
          "indent2em",
          '<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M170.666667 563.2v-102.4H887.466667v102.4zM170.666667 836.266667v-102.4H887.466667v102.4zM512 290.133333v-102.4H887.466667v102.4zM238.933333 341.333333V136.533333l204.8 102.4z" fill="#2c2c2c" p-id="5210"></path></svg>'
        );
      editor.ui.registry.addButton("indent2em", {
        tooltip: "首行缩进",
        icon: "indent2em",
        onAction: function () {
          doAct(editor);
        },
      });
      editor.ui.registry.addMenuItem("indent2em", {
        text: "首行缩进",
        icon: "indent2em",
        onAction: function () {
          doAct(editor);
        },
      });
    };

    global.add("indent2em", function (editor) {
      register(editor);
    });

    function Plugin() {}

    return Plugin;
  })();
})();
